import type { ReactNode } from 'react';

import Link from '~/(tenant)/_components/tenant-link';

export function SmartLink({ href, className, children, motionItem, ariaHidden }: {
  href: string;
  className?: string;
  children: ReactNode;
  motionItem?: boolean;
  ariaHidden?: boolean;
}) {
  const hidden = ariaHidden ? { 'aria-hidden': true, tabIndex: -1 } : {};
  if (/^https?:\/\//i.test(href)) {
    return <a href={href} target="_blank" rel="noopener noreferrer" className={className} data-motion-item={motionItem || undefined} {...hidden}>{children}</a>;
  }
  return <Link href={href} className={className} data-motion-item={motionItem || undefined} {...hidden}>{children}</Link>;
}
